// removed by extract-text-webpack-plugin
module.exports = {"banner":"banner_3k2VG","welcome":"welcome_Zb6G2","button":"button_2CH_o","calandar":"calandar_2HVwG","boardBlock":"boardBlock_1aDJB","board-button":"board-button_3zAfG","body":"body_1CMf5","warning":"warning_1NuqS","li-usual":"li-usual_1Mv6b","li-stop":"li-stop_c8iQf"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/applyMain/style.css
 ** module id = 327
 ** module chunks = 0
 **/